import { useEffect } from 'react';
import { analyticsEnabled, TAPFILIATE_ACCOUNT_ID } from './analyticsConfig.js';

// Loads Tapfiliate: define the window.tap stub, load the script, then init
// (Stripe integration) and detect the affiliate referral on load.
const Tapfiliate = () => {
  useEffect(() => {
    if (!analyticsEnabled || !TAPFILIATE_ACCOUNT_ID) return;
    if (window.tap) return; // already injected

    (function (t, a) {
      t.TapfiliateObject = a;
      t[a] =
        t[a] ||
        function () {
          (t[a].q = t[a].q || []).push(arguments);
        };
    })(window, 'tap');

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://script.tapfiliate.com/tapfiliate.js';
    script.onload = () => {
      window.tap('create', TAPFILIATE_ACCOUNT_ID, { integration: 'stripe' });
      window.tap('detect');
    };
    document.head.appendChild(script);
  }, []);

  return null;
};

export default Tapfiliate;
